import { Component, OnDestroy, OnInit } from '@angular/core';

import { Config } from 'src/app/core/configs/config';
import { ERoutes } from 'src/app/core/enums/routes.enum';

import { SsrHelperService } from 'src/app/core/services/ssr-helper.service';
import { CloudinaryService } from 'src/app/core/services/cloudinary.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { TestimonialsService } from 'src/app/core/services/testimonials.service';
import { MetaTagsConfigService } from 'src/app/core/services/meta-tags-config.service';

@Component({
  selector: 'app-trip-testimonials',
  templateUrl: './trip-testimonials.component.html',
  styleUrls: ['./trip-testimonials.component.scss'],
  standalone: false,
})
export class TripTestimonialsComponent implements OnInit, OnDestroy {
  public pageLimit = 3;
  public pageOffset = 0;
  public pagedTestimonials: any[] = [];

  protected readonly cdnUrl = Config.cdnUrl.substring(
    0,
    Config.cdnUrl.length - 1,
  );
  public allCustomerTestimonials: any[] = [];

  constructor(
    public cloudinaryService: CloudinaryService,
    private testimonialsService: TestimonialsService,
    private metaTagsConfigService: MetaTagsConfigService,
    private ssrHelperService: SsrHelperService,
    protected breakpointService: BreakpointService,
  ) {
    this.metaTagsConfigService.setMetaTags(ERoutes.TRIP_TESTIMONIALS);
  }

  ngOnInit(): void {
    if (!this.ssrHelperService.userAgent) {
      return;
    }

    this.testimonialsService
      .fetchRandomTestimonials()
      .subscribe((res: any[]) => {
        if (res) {
          this.allCustomerTestimonials = res;
          this.allCustomerTestimonials.forEach((testimonial: any) => {
            if (!testimonial.map.includes('cloudinary')) {
              testimonial.map = this.cloudinaryService.getCloudImage(
                this.cdnUrl + testimonial.map,
              );
              testimonial.picture = this.cloudinaryService.getCloudImage(
                this.cdnUrl + testimonial.picture,
              );
            }
          });

          this.loadMore();
        }
      });
  }

  ngOnDestroy(): void {
    this.metaTagsConfigService.removeMetaTags();
  }

  public loadMore(e?: MouseEvent) {
    if (e) {
      e.preventDefault();
    }

    const slicedItems = this.allCustomerTestimonials.slice(
      this.pageOffset,
      this.pageOffset + this.pageLimit,
    );

    this.pageOffset = this.pageOffset + this.pageLimit;
    this.pagedTestimonials = this.pagedTestimonials.concat(slicedItems);
  }
}
